import { useEffect, useState } from "react";
// import "./styles/indicadores.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
// import General from "./General";
// import WorkStation from "./WorkStation";
// import Printers from "./Printers";
// import Phones from "./Phones";
// import AccessPoint from "./AccesPoint";
// import Switches from "./Switches";
// import Routers from "./Routers";
// import Laptops from "./Laptops";
// import Fingerprints from "./Fingerprints";
import PanelCis from "./PanelCis";
// import PanelMedicionesMapeoAplicados from "./pending_aplicados/PanelMedicionesMapeoAplicados";
import PanelCatalogMediciones from "./pending/PanelCatalogMediciones";
import Modal from "react-modal";
// import ModalEvents from "./ModalEvents";
// import PanelDevice from "./PanelDevice";
import { useFetch } from "../../hooks/useFetch";
import { permisos_codigo_id } from "../generales/GroupsId";
import LoadData from "../LoadData";
import LoadSimple from "../LoadSimple";
import PanelFolios from "./Folios/PanelCatalogMediciones";
import PanelFoliosHistorico from "./Historico/PanelCatalogMediciones";
const addHostModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'80%',
    height:'70%',
    padding:'20px'
  },
};
const PanelCMDB = ({handleShowPopup,pageSelected, globals,server, dataGlobals,languaje,mode,estados_list,userPermissions,token,estadoSelected,setEstadoSelected}) => {
  const [listSelected, setListSelected] = useState(1);
  const [techSelected, setTechSelected] = useState(0);
  const [internalError,setInternalError]=useState(false)
  const [hostSelected,setHostSelected]=useState({})
  // const dataTechs=useFetch('zabbix/groups/devices/0','',token,'GET',server)
  // const pendingList=useFetch('cassia/cis_v2/authorizations/pending_all','','','GET',server)

  const [FoliosList, setFoliosList] = useState({
    data: [],
    loading: true,
    error: null,
  });

  const [pendingList, setPendingList] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const buscar_folios = () => {
    // setLoadingCis(true)
    setFoliosList({
    data: FoliosList.data,
    loading: true,
    error: null,
  });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/cis_v2/folios/pending_all",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setFoliosList({
    data: data1,
    loading: false,
    error: null,
  });
        } else {
          const data1 = await response.json();
          
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const buscar_auths = () => {
   setPendingList({
    data: pendingList.data,
    loading: true,
    error: null,
  });
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/cis_v2/authorizations/pending_all",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setPendingList({
    data: data1,
    loading: false,
    error: null,
  });
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const users_catalog=useFetch('cassia/cis_v2/users_catalog','','','GET',server)

  const hadleChangeList = (e,tite) => {
    setListSelected(e);
    setTechSelected(tite)
  };
  const [addHostModalOpen, setAddHostModalOpen] =useState(false);
  function openAddHostModal() {
      
    //   console.log('open')
      setAddHostModalOpen(true);
    }

  function closeAddHostModal() {
   
      setAddHostModalOpen(false);
  }
  function showHistoric(element){
    setHostSelected(element); // Esto debería funcionar si se pasa correctamente
    openAddHostModal();      // Esto también
}
  function getTechDisp(permissions, devices) {
  const moduleName = permissions.find(p => p.description === 'lista tecnologías')?.module_name;
  return devices.find(d => d.name === moduleName) ?? null;   // ← { dispId, name, id }
}


  const [dataAnalisis,setDataAnalisis]=useState({data:{},loading:true,error:{}})
  const token_item=localStorage.getItem('access_token')


  function renderAdminComponent() {
    try {
        switch (listSelected) {
            case 1:
                return <PanelCis  buscar_auths={buscar_auths} buscar_folios={buscar_folios} users_catalog={users_catalog} FoliosList={FoliosList.data} pendingList={pendingList.data} userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
                ;
            case 2:
                return <PanelCatalogMediciones  buscar_auths={buscar_auths} buscar_folios={buscar_folios} pendingList={pendingList.data} userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
                ;
            case 3:
                return <PanelFolios setFoliosList={setFoliosList} buscar_auths={buscar_auths} buscar_folios={buscar_folios} pendingList={FoliosList.data} userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
                ;
             case 4:
                return <PanelFoliosHistorico pendingList={FoliosList.data} userPermissions={userPermissions} handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server}/>
                ;    
                            // case 4:
                            //     return <Phones
                            //               mode={mode}
                            //               handleShowPopup={handleShowPopup}
                            //               server={server}
                            //               title='Phone'
                            //               languaje={languaje}
                            //               showHistoric={showHistoric}
                            //             />
                            //         ;
                                  default:
                return <></>;
        }
    } catch (error) {
        console.error('Error rendering component:', error);
        return <div>{lang[languaje['msgErrorPagina']]}</div>;
    }
  }
  return (
    <>
    <div className={"main-config"+mode}>
       {/* {(internalError)?
            <InternalError/>
            :renderAdminComponent()} */}
       <div className='head-monitor'>
                
                <div className='menu-monitor'>
                     <ol className='compact-menu-list-monitor' style={{justifyContent:'start'}}>
                       
                        <li className={listSelected===1?'list-selected':''} onClick={() =>hadleChangeList(1)}>{'CI´s'}</li>
                        <li className={listSelected===3?'list-selected':''} onClick={() =>hadleChangeList(3)}>{(FoliosList.data.length==0?'':<strong style={{color:'var(--red-alert)'}}>{'('+FoliosList.data.data.length+')'}</strong>)}&nbsp;{' Folios Pendientes'}</li>
                        {/* <li className={listSelected===2?'list-selected':''} onClick={() =>hadleChangeList(2)}>{(pendingList.data.length==0?'':<strong style={{color:'var(--red-alert)'}}>{'('+pendingList.data.data.length+')'}</strong>)}&nbsp;{' Pendientes Autorización'}</li> */}
                         <li className={listSelected===4?'list-selected':''} onClick={() =>hadleChangeList(4)}>{'Historico'}</li>
                        {/* <li className={listSelected===2?'list-selected':''} onClick={() =>hadleChangeList(2)}>{'Catalogo de mapeos'}</li>
                        <li className={listSelected===3?'list-selected':''} onClick={() =>hadleChangeList(3)}>{'Mapeos Aplicados'}</li> */}
                        {/* <li className={listSelected===4?'list-selected':''} onClick={() =>hadleChangeList(4)}>{capitalizeFirstLetter(lang[languaje]['telefonos'])}</li> */}
                       
                     
                    </ol>
                    <hr className='head-line-monitor'></hr>
                </div>
                
            </div>
            <div className='cont-monitor'>
            {(internalError)?
              <InternalError/>
              :((false)?<LoadSimple/>:renderAdminComponent())

            }
            
                
            </div>
    </div>
    <Modal
    isOpen={addHostModalOpen}
    // isOpen={true}
    // onAfterOpen={afterOpenExeption}
    onRequestClose={closeAddHostModal}
    style={addHostModalStyles}
    contentLabel="Example Modal2"
    // shouldCloseOnOverlayClick={false}
    >
      {/* <ModalEvents dataCriticalities={dataCriticalities}  dataAgencies={dataAgencies} dataServers={dataServers} deviceId={listSelected} server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalEvents>  */}
      {/* <ModalHistoric  server={server} handleShowPopup={handleShowPopup}  hostSelected={hostSelected}  languaje={languaje}  mode={mode} closeAddHostModal={closeAddHostModal} ></ModalHistoric> */}
</Modal>

</>
  );
};

export default PanelCMDB;
